var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck24DpFill0Wght400Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck24DpFill0Wght400Grad0Opsz24);
export default __webpack_public_path__ + "static/media/check_24dp_FILL0_wght400_GRAD0_opsz24.14ef6b5f03f1276e855936235c6b5d58.svg";
export { ForwardRef as ReactComponent };